import { useMutation } from '@tanstack/react-query';
import { DocQuizRevision } from '~/monolith-api';
import { attachQuizToGuide } from '~/pages/api/quizzes';

type CreateGuideQuizRequest = {
   guideid: number;
   quizid: number;
};

export function createGuideQuizKey() {
   return ['create-guide-quiz'];
}

export function useCreateGuideQuizRevision() {
   const mutationFunction = async ({
      guideid,
      quizid,
   }: CreateGuideQuizRequest): Promise<DocQuizRevision> => {
      const result = await attachQuizToGuide(guideid, quizid);

      return result;
   };

   return useMutation({
      mutationFn: mutationFunction,
      mutationKey: createGuideQuizKey(),
   });
}
